import OrderStatus from './OrderStatus.view';

export default OrderStatus;
